<template>
  <div
    class="w-full flex justify-between items-center px-6 py-4 text-white relative h-[65px] min-[768px]:h-[73px] border-[#1A528E] border-b-[1px] min-[768px]:border-none"
  >
    <MobileMenu :content="props.content" />
    <a href="/" aria-label="Homepage">
      <Logo aria-hidden="true" :title="`${brandName} logo`" class="h-8 min-[768px]:h-10 w-auto" />
    </a>
    <button @click="openSearchBar" class="h-8 w-8 p-1 flex-shrink-0" type="button">
      <SearchIcon2024 v-if="!isSearchBarOpen" class="w-full h-full" />
      <CloseIcon v-else class="w-full h-full p-1" />
    </button>
    <div
      v-if="isSearchBarOpen"
      ref="searchBarContainer"
      class="absolute z-50 w-screen bg-[#003F82] left-0 -bottom-[64px] flex items-center justify-center h-full"
    >
      <div class="w-full mx-6 min-[768px]:mx-0 min-[768px]:w-[460px] h-[39px] flex">
        <SearchBar variant="navbar" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import SearchBar from "../../SearchBar/SearchBar.vue";
import MobileMenu from "./MobileMenu.vue";
import type { DRXNavigationContent } from "../types";
import MedexpressLogo from "../../../resources//logos/medexpress-logo.svg?inline";
import ZiphealthLogo from "../../../resources/logos/ziphealth-logo.svg?inline";
import SearchIcon2024 from "../../../resources/search.svg?inline";
import CloseIcon from "../../../resources/close.svg?inline";

const props = defineProps<{
  brandName: string;
  content: DRXNavigationContent;
}>();

const logos = {
  medexpress: MedexpressLogo,
  ziphealth: ZiphealthLogo,
};

const Logo = logos[props.brandName];

const isSearchBarOpen = ref(false);
const searchBarContainer = ref(null);

const openSearchBar = () => {
  isSearchBarOpen.value = true;
};

onClickOutside(searchBarContainer, (event) => {
  if (isSearchBarOpen.value) {
    event.stopPropagation();
    isSearchBarOpen.value = false;
  }
});
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
